const message = {
    accept: "Terima",
    accept_order: "Terima Order",
    account_group: "Account Group",
    add_to_shipment: "Tambah ke Shipment",
    address1: "Address1",
    address2: "Address2",
    address3: "Address3",
    address4: "Address4",
    address5: "Address5",
    address: "Alamat",
    all_business_segment: "All Product Category",
    all_commodity_group: "All Commodity Group",
    all_company: "All Company",
    all_distribution: "All Distribution",
    all_location: "All Location",
    all_plant: "All Plant",
    all_purchase_organization: "All Purchase Organization",
    all_sales_organization: "All Sales Organization",
    alternative_uom: "Alternative UOM",
    amount: "Jumlah",
    appointment_date: "Tgl Appointment",
    appointment_matrix: "Appointment Matrix",
    appointment_schedule: "Jadwal",
    appointment_status: "Status Appointment",
    appointment_status_date: "Tgl Approval Warehouse",
    appointment_status_remarks: "Remarks Status Appointment",
    appointment_time:"Waktu Appointment",
    approval: "Approval",
    approval_by: "Approval Oleh",
    approval_confirmation: "Konfirmasi Approval",
    approval_date: "Tgl Approval",
    approval_matrix: "Approval Matrix",
    approve: "Approve",
    assign_customer_vendor: "Berikan ke Customer/Vendor",
    assign_reason: "Alasan",
    assign_to_driver: "Penetapan Pengemudi & Truk",
    assign_to_transporter: "Penetapan Transporter",
    auto_reject_date: "Tgl Penolakan Otomatis",
    back: "Kembali",
    base_freight_cost: "Base OA",
    base_freight_per: "Base OA Per",
    base_freight_uom: "Base OA UOM",
    base_uom:"Base UOM",
    blacklist_reason:"Blokir & Alasan",
    blocked: "Blocked",
    by_proceeding_privacy_consent: "Dengan melanjutkan, anda setuju dengan ",
    cancel_order: "Batalkan Order",
    cancel_shipment: "Batalkan Shipment",
    cancelled: "Cancelled",
    capacity:"Kapasitas",
    capacity_kg:"Kapasitas (KG)",
    category: "Kategori",
    change_stuffing_date:"Edit Est Tgl Muat/Bongkar",
    charge_oa_company: "Charge OA Company",
    city: "City",
    clear: "Unfilter",
    close:"Tutup",
    code: "Kode",
    collective_ln: "Collective LN",
    commodity: "Commodity",
    commodity_group: "Commodity Group",
    company: "Company",
    company_code: "Company Code",
    completed_date: "Tgl Complete",
    contact_person :"Contact Person",
    convert_shipment: "Convert Shipment",
    country: "Country",
    create: "Buat Baru",
    create_appointment: "Buat Appointment",
    created_by : "Dibuat Oleh",
    created_date: "Created Date",
    credit_group: "Credit Group",
    credit_group_desc: "Credit Group Desc.",
    currency: "Currency",
    current_stuffing_date: "Current Stuffing Date",
    customer: "Customer",
    customer_vendor: "Customer/Vendor",
    customer_vendor_notes: "Customer/Vendor Notes",
    date_of_birth:"Tanggal Lahir",
    delete: "Delete",
    deleted_by: "Dihapus Oleh",
    deleted_date: "Tanggal Penghapusan",
    delivery_address: "Alamat Pengiriman",
    delivery_no: "No. Delivery",
    delivery_order_no: "No. Delivery Order",
    delivery_qty: "Qty Delivery",
    denominator: "Denominator",
    department: "Department",
    description: "Description",
    destination: "Tujuan",
    discharge_port: "Discharge Port",
    dispatch_status: "Transporter Accept Status",
    dispatch_status_reason: "Alasan",
    distribution: "Distribusi",
    distribution_channel: "Distribution Channel",
    division: "Division",
    do_bl_no: "No. DO BL",
    doc_date: "Tgl Doc.",
    doc_type: "Tipe Doc.",
    document_date: "Tgl Doc.",
    document_no: "No. Doc",
    document_type: "Tipe Document",
    driver: "Pengemudi",
    driver_name:"Nama Pengemudi",
    edit: "Edit",
    edit_appointment: "Edit Appointment",
    edit_order: "Edit Order",
    edit_sap_order: "Edit SAP Order",
    edit_shipment: "Edit Shipment",
    edited_by: "Diedit Oleh",
    edited_date: "Tgl Pengeditan",
    email: "Email",
    emp_number: "Employee Number",
    epod: "ePOD",
    estate:"Estate",
    exclude_loading_cost: "Exclude Loading Cost",
    exclude_unloading_cost: "Exclude Unloading Cost",
    factory: "Pabrik",
    fax:"Fax",
    freight: "Freight",
    freight_best_price: "Total Biaya (Best Price)",
    freight_best_price_uom: "Best Price/UOM",
    freight_cost: "Biaya Pengiriman (Per UOM)", //"Biaya Pengiriman (Per UOM)",
    freight_cost_base: "Freight Cost",
    freight_cost_master: "Freight Cost Master",
    freight_cost_per: "Freight Per",
    freight_cost_suggested: "Biaya Pengiriman yang Dipilih",
    freight_cost_uom: "Freight UOM",
    freight_date: "Freight Cost Date",
    freight_different_per_uom: "Different Per UOM",
    freight_different_percentage: "Percentage Different",
    freight_kg: "RP/KG (Based Qty Kirim)",
    freight_kg_based: "RP/KG (Based Capacity)",
    freight_master: "Harga OA (Master Data)",
    freight_per: "Per UOM",
    freight_total: "Total Biaya Pengiriman",
    freight_total_cost: "Est. Total Biaya Pengiriman", //Est. Total Biaya Pengiriman
    freight_total_cost_user_not: "Freight Total Cost", // "Total Biaya Pengiriman",
    freight_total_different: "Total Different",
    freight_value: "Freight Value",
    full_name: "Full Name",
    generate_qr: "Generate QR",
    group: "Group",
    has_order: "Order",
    has_shipment: "Shipment",
    has_tracking: "Tracking",
    header_details:"Header & Detail",
    history_log: "Lihat Riwayat Status",
    inactive_account: "Akun ini tidak aktif sudah lebih dari 90 hari.",
    incoterm2: "Incoterm2",
    incoterm: "Incoterm",
    incoterm_name: "Incoterm",
    info1: "Info1",
    info2: "Info2",
    is_deleted:"Deleted",
    is_admin: "Admin",
    item_no: "No. Item",
    latitude: "Latitude",
    longitude: "Longitude",
    last_approval_by: "Last Approval By",
    last_approval_date: "Last Approval Date",
    level: "Level",
    license_no: "No. Lisensi",
    ln_do_third_party: "LN DO 3rd Party",
    ln_so_item_no: "LN SO Item No.",
    ln_so_no: "LN SO No.",
    ln_sto_item_no: "LN STO Item No.",
    ln_sto_no: "LN STO No.",
    loading: "Tempat Muat",
    loading_dest_from:"Tempat Muat",
    location1: "Location From",
    location2: "Location To",
    location: "Location",
    lock_wb: "Lock WB",
    lookup: "Lookup",
    lookup_group: "Lookup Group",
    lookup_info1: "Lookup Info1",
    lookup_info2: "Lookup Info2",
    lookup_key: "Lookup Key",
    lookup_value: "Lookup Value",
    mark_complete: "Mark Complete",
    mark_deleted: "Mark Deleted",
    material: "Material",
    material_code: "Material Code",
    material_conversion: "Material Conversion",
    material_description:"Material Description",
    material_name: "Material",
    matrix: "Matrix",
    max_slot: "Slot Maksimal",
    menu: "Menu",
    merge_order: "Gabung Shipment",
    mode: "Mode",
    name1: "Name1",
    name2: "Name2",
    name3: "Name3",
    name4: "Name4",
    name:"Name",
    number_of_trips: "Number of Trips/UOM",
    numberoftripuom: "Trip UOM",
    numerator: "Numerator",
    order: "Order",
    order_item_no: "No. Item Order",
    order_no : "No. Order",
    order_os_qty: "O/S Qty Order",
    order_qty: "Qty Order",
    order_type: "Tipe Order",
    os_qty: "Qty O/S",
    partner_function: "Partner Function",
    password:"Kata Sandi",
    payment_term: "Payment Term",
    phone: "Phone",
    pkp_no: "PKP No",
    pkp_validity: "PKP Validity",
    plant: "Plant",
    po_no: "PO No.",
    po_so_no: "PO SO",
    pod: "ePOD",
    pod_date: "POD Date",
    pod_notes: "Catatan",
    pod_upload_file: "Upload file(s)",
    port: "Port",
    postal_code: "Postal Code",
    product_category: "Kategori Produk",
    product_category_itm: "Product Category (ITM)",
    product_category_sap: "SAP Product Category",
    product_group: "Product Group",
    progress_status: "Status Progres",
    pur_sales_org: "Pur/Sales Org.",
    purchase_org: "Purchase Org.",
    purchase_organization: "Purchase Organization",
    privacy_policy_consent_header: "Privacy Policy & Consent",
    privacy_policy: "Kebijakan Privasi",
    privacy_check_box: "Saya telah membaca dan menyetujui Privacy Policy & Terms of Service",
    qty: "Qty",
    qty_kg: "Qty (KG)",
    quota: "Quota",
    quota_by: "Quota By",
    quota_per: "Quota Per",
    real_qty: "Qty Realisasi",
    reason: "Alasan",
    reassign_do: "Reassign DO",
    receive_qty: "Qty terima",
    ref_no: "No. Ref",
    ref_doc_no: "No. Doc. Ref",
    region: "Region",
    region_desc: "Region Desc",
    reject: "Reject",
    reject_order:"Tolak Order",
    release_status : "Status Release",
    remaining_slot: "Sisa Slot",
    remarks: "Remarks",
    return_qty: "Qty Retur",
    revert_qty: "Qty Revert",
    sales_district: "Sales District",
    sales_org: "Sales Org.",
    sales_organization: "Sales Organization",
    sap_freight_cost :"SAP Freight Cost",
    sap_item_no: "SAP Item No.",
    sap_no : "SAP No.",
    sap_order: "SAP Order",
    sap_order_no:"SAP Order No.",
    sap_order_os_qty: "O/S SAP Qty",
    save: "Save",
    shipment: "Shipment",
    shipment_item_no: "Shipment Item No.",
    shipment_no: "Shipment No.",
    shipment_qty: "Shipment Qty",
    shipment_tracking :"Shipment Tracking",
    shipment_type: "Shipment Type",
    slot_name: "Slot Name",
    so_do_no: "SO dari DO No",
    status: "Status",
    status_from: "Dari Status",
    status_to: "Ke Status",
    sto_item_no: "No. Item STO",
    sto_no: "No. STO",
    sto_qty: "Qty STO",
    sto_uom: "STO UOM",
    street: "Street",
    stuffing_date: "Est Tgl Muat/Bongkar",
    sub_status_from: "Dari Status Progress",
    sub_status_to: "Ke Status Progress",
    system_num_trip: "No. Trips Based Capacity", //"System No. Trips",
    term_of_service: "Syarat Ketentuan",
    time_from: "Time From",
    time_to: "Time To",
    tolerance: "Toleransi",
    total_real_qty: "Total Real. Qty",
    transfer_type: "Jenis Transfer",
    transport_type: "Jenis Transport",
    transporter: "Transporter",
    transporter_status: "Status Transporter",
    transporter_notes: "Catatan untuk Transporter",
    transporter_quota: "Transporter Quota",
    truck:"Truk",
    truck_type: "Jenis Truk",
    type: "Tipe",
    upload_file: "Upload File",
    upload_transporter: "Upload Transporter Data",
    unmark_complete: "Unmark Complete",
    uom: "UOM",
    use_ad: "Use AD",
    user: "User",
    user_num_trip: "No. Trips by User", //User No. Trips",
    username:"Username",
    validity: "Validity",
    valid_date: "Valid Date SAP Order",
    valid_from: "Valid From",
    valid_to: "Valid To",
    vehicle_no: "Truck",
    vendor: "Vendor",
    view: "Lihat",
    view_epod: "Lihat ePOD",
    view_history: "Lihat Riwayat Status",
    view_order: "Lihat Order",
    view_orders: "Lihat Order",
    view_pod: "Lihat/Edit POD",
    view_realization: "Lihat Realisasi",
    view_sap_order: "Lihat SAP Order",
    view_shipments: "Lihat Shipment",
    warehouse: "Pabrik",
    warehouse_location: "Lokasi Pabrik",
    we: " kami",
    wb_trans_type: "WB Trans Type",
    yes: "Ya",
    no: "Tidak",

    version: "Version",
    version_date: "Version Date",
    changelog: "Changelog",
    version_active: "Active Version",
    truck_rental: "Truck Rental",
    exclude_approval: "Exclude Approval",

    pic_contract:"PIC Contract",
    pic_id:"PIC ID",
    pic_name:"PIC Name",
    number_trip:"Number of Trips",
    spo_item_no:"SPO Item No",
    without_price:"Tanpa Harga",
    header_text:"Header Text",
    pib_no:"PIB No.",
    fba_no:"FBA No.",
    contract_no:"Contract No.",
    contract_date:"Contract Date",
    with_contract:"With Contract",
    pic:"PIC",
    pic_location:"PIC Location",
    header_note:"Header Note",
    pricing_types:"Pricing Type",
    deadlines:"Deadlines",
    terms_of_delivery:"Terms of Delivery",
    shipping_instructions:"Shipping Instructions",
    payment_method:"Payment Method",
    warranties:"Warranties",
    penalty:"Penalty",
    guarranties:"Guarranties",
    contract_riders:"Contract Riders",
    other_contractual:"Other Contractual Stipulations",
    loading_destination:"Tempat Muat/Tujuan",
    vendor_memo:"Vendor Memo (General)",
    transport_mode:"Transport Mode/Vessel Name",
    cost_center:"Cost Center for Tolling",
    laytime:"Laytime",
    demurrage:"Demurrage",
    approval_remarks:"Approval Remarks",
    transfer_to:"Transfer To",
    doc_reference:"Doc Reference",
    contract_person:"Contract Person",
    address:"Address",
    po_change_revision:"PO Change Revision",
    plate_no:"Plate No/Container/Resi",
    per:"Per",
    ccy:"Ccy",
    delivery_date:"Delivery Date",
    plant_supplying:"Supplying Plant",
    plant_receiving:"Receiving Plant",
    tolerance_over:"Over. Tolerance",
    tolerance_under:"Under. Tolerance",
    tolerance_expeditor:"Expeditor Tole%",
    transaction_type:"Transaction Type",
    tracking_no:"Tracking No",
    mat_doc_year:"Material Doc. Year",
    grdaily:"ZGR Daily",
    continuous:"Continuous",
    valuation_type:"Valuation Type",
    previous_sto:"Previous STO",
    guarantees:"Guarantees",
    ipb_no:"IPB No.",
    ipb_item_no:"IPB Item No",
    item_text:"Item Text",
    material_po_text:"Material PO Text",
    delivery_text:"Delivery Text",
    ipb:"IPB",
    phase_date:"Phase Date",
    so_factory_no:"SO Factory No",
    so_factory_item_no:"Item",
    result:"Result",
    delivery_using_truck:"Delivery Using Truck",
    ln_type:"LN Type",
    incoterm_rule:"Incoterm Rule",
    language:"Language",
    salesperson:"Salesperson",
    telephone:"Telephone",
    your_reference:"Your Reference",
    our_reference:"Our Reference",
    communication:"Communication",
    zfrcost_no:"ZFRCost No",
    pod_requirement:"POD Control",
    all_document_type:"All Document Type",
    appointment_requirement:"Appointment Control",
    active:"Active",
    all_order_type:"All Order Type",
    sto_spo_per_shipment:"STO/SPO Per Shipment",
    plant_destination:"Plant Destination",
    factory_destination:"Factory Destination",
    langsir_type:"Langsir Type",
    show_info:"Show Info",
    hide_info:"Hide Info",
    report_date:"Report Date",
    registration_in_date:"Registration In",
    registration_out_date:"Registration Out",
    frc_term:"Terms of FRC",
    service:"Service",
    service_type:"Service Type",
    service_category:"Service Category",
    adjustment_lot:"Adjustment Lot",
    required_spr:"Required SPR",
    same_uom:"Same UOM",
    quantity_term:"Quantity Terms",
    spo_no:"SPO No.",
    purchase_group:"Purchase Group",
    edit_assign_transporter:"Edit Assign Transporter",
    sto:"STO",
    spo:"SPO",
    filter_by:"Filter By",
    version:"Version",
    version_date:"Version Date",
    changelog:"Changelog",
    version_active:"Active Version",
    truck_rental:"Truck Rental",
    exclude_approval:"Exclude Approval",
    pic_contract:"PIC Contract",
    pic_id:"PIC ID",
    pic_name:"PIC Name",
    number_trip:"Number of Trips",
    spo_item_no:"SPO Item No",
    without_price:"Without Price",
    header_text:"Header Text",
    pib_no:"PIB No.",
    fba_no:"FBA No.",
    contract_no:"Contract No.",
    contract_date:"Contract Date",
    with_contract:"With Contract",
    pic:"PIC",
    pic_location:"PIC Location",
    header_note:"Header Note",
    pricing_types:"Pricing Type",
    deadlines:"Deadlines",
    terms_of_delivery:"Terms of Delivery",
    shipping_instructions:"Shipping Instructions",
    payment_method:"Payment Method",
    warranties:"Warranties",
    penalty:"Penalty",
    guarranties:"Guarranties",
    contract_riders:"Contract Riders",
    other_contractual:"Other Contractual Stipulations",
    loading_destination:"Tempat Muat/Tujuan",
    vendor_memo:"Vendor Memo (General)",
    transport_mode:"Transport Mode/Vessel Name",
    cost_center:"Cost Center for Tolling",
    laytime:"Laytime",
    demurrage:"Demurrage",
    approval_remarks:"Approval Remarks",
    transfer_to:"Transfer To",
    doc_reference:"Doc Reference",
    contract_person:"Contract Person",
    address:"Address",
    po_change_revision:"PO Change Revision",
    plate_no:"Plate No/Container/Resi",
    per:"Per",
    ccy:"Ccy",
    delivery_date:"Delivery Date",
    plant_supplying:"Supplying Plant",
    plant_receiving:"Receiving Plant",
    tolerance_over:"Over. Tolerance",
    tolerance_under:"Under. Tolerance",
    tolerance_expeditor:"Expeditor Tole%",
    transaction_type:"Transaction Type",
    tracking_no:"Tracking No",
    mat_doc_year:"Material Doc. Year",
    zgrdaily:"ZGR Daily",
    continuous:"Continuous",
    valuation_type:"Valuation Type",
    previous_sto:"Previous STO",
    guarantees:"Guarantees",
    ipb_no:"IPB No.",
    ipb_item_no:"IPB Item No",
    item_text:"Item Text",
    material_po_text:"Material PO Text",
    delivery_text:"Delivery Text",
    ipb:"IPB",
    phase_date:"Phase Date",
    so_factory_no:"SO Factory No",
    so_factory_item_no:"Item",
    result:"Result",
    delivery_using_truck:"Delivery Using Truck",
    ln_type:"LN Type",
    incoterm_rule:"Incoterm Rule",
    language:"Language",
    salesperson:"Salesperson",
    telephone:"Telephone",
    your_reference:"Your Reference",
    our_reference:"Our Reference",
    communication:"Communication",
    zfrcost_no:"ZFRCost No",
    sto_type:"STO Type",
    spo_type:"SPO Type",
    ipb_no:"IPB No.",
    filter_order_ipb:"Order",
    spo_adjustment:"SPO Adjustment",
    spo_adjustment_no:"SPO Adjustment No.",
    spr_no:"SPR No.",
    spr_item_no:"SPR Item No.",
    result_data_sap:"Result",
    service_no:"Service No.",
    short_text:"Short Text",
    gross_price:"Gross Price",
    service_code:"Service Code",
    order_create_date:"Order Create Date",
    shipment_create_date:"Shipment Create Date",
    wb_ref_no:"WB Ref No.",
    wb_report_date:"WB Report Date",
    delivery_item_no:"Delivery Item No.",
    services:"Services",
    ref_spo:"Ref SPO No.",
    ref_spo_item:"Ref SPO Item",
    material_info:"Material Info",
    do_no:"DO No.",
    po_so_factory:"PO/SO Factory",
    po_so_contract_item_no:"PO/SO/Contract Item No",
    condition_type_header:"Condition Type Header",
    approval_status:"Status Approval",
    freight_cost_from:"Freight Cost Original",
    num_trip_to:"No Of Trips by User",
    freight_total_cost_user_not_to:"Total OA Revisi",
    freight_cost_to:"OA yang di Revisi",
    freight_total_cost_user_not_from:"OA Awal (Original)",
    freight_different_per_uom:"Different Per UOM",
    freight_different_percentage:"Percentage Different",
    freight_different_total:"Total Different",
    service_adjustment:"Service Code",
    qty_adjustment:"Amount Adjustment",
    uom_adjustment:"UOM Adjustment",
    gross_price_adjustment:"Gross Price Adjustment",
    per_adjustment:"Per UOM Service",
    condition_type_oa:"Condition Type OA STO",
    per_oa:"Per UOM",
    uom_oa:"UOM STO",
    vat_regulation:"VAT Regulation",
    filter:"Filter",


    alert:{
        require_address: "Wajib isi alamat",
        require_charge_oa_company: "Charge OA Company wajib di isi",
        require_date_of_birth: "Tanggal Lahir wajib di isi",
        require_destination: "Tujuan wajib di isi",
        require_driver: "At least 1(one) or more driver(s) required",
        require_freight_date: "Tanggal OA wajib di isi",
        require_license_no: "No SIM wajib di isi",
        require_loading: "Tempat Muat wajib di isi",
        require_name: "Nama wajib di isi",
        require_qty_assign_driver: "Tidak dapat menetapkan pengemudi jika Qty kosong",
        require_driver_assign_driver: "Pengemudi wajib di isi",
        require_vehicle_assign_driver: "Truk wajib di isi",
        require_reason: "Asalan wajib di isi",
        require_shipment_no: "No. Shipment wajib di isi",
        require_slot: "Slot wajib di isi",
        require_stuffing_date: "Est. Tgl Muat Bongkar wajib di isi",
        require_transporter: "Transporter wajib di isi",
        require_remarks: "Remarks wajib di isi",

        require_wb_report_date: "WB Report Date wajib diisi",

        require_distribution: "Distribution wajib diisi",
        require_commodity_group: "Commodity group wajib diisi",
        require_company: "Company wajib diisi",
        require_document_date: "Document Date wajib diisi",
        require_order_type: "Order Type wajib diisi",
        require_document_type: "Document Type wajib diisi"
       
    },
    message:{
        approval_confirmation: "Are you sure? These selected document(s) will be ",
        transporter_action_confirmation_accept: "Apakah anda yakin untuk terima order ini?",
        transporter_action_confirmation_reject: "Apakah anda yakin untuk tolak order ini?",
        sap_filter_authorization: "Baris berwarna menandakan anda tidak mempunyai otorisasi untuk menyimpan"
    }
}

export default message;